// extracted by mini-css-extract-plugin
module.exports = {"tableWrap":"EnrolledClinics_tableWrap__3ZaYG","actionsCol":"EnrolledClinics_actionsCol__PyhdR"};